module.exports = __webpack_public_path__ + "static/media/people-outline.222ca077.svg";